import WhenAdjustGoal from "../../../../../images/posters/fbbc/app/when-adjust-goal.webp";
import WaterWeight from "../../../../../images/posters/fbbc/app/water-weight.webp";
import VacationMode from "../../../../../images/posters/fbbc/app/vacation-mode.webp";
import TurnOnDailyWeights from "../../../../../images/posters/fbbc/app/turn-on-daily-weights.webp";
import TurnOffFastingTimer from "../../../../../images/posters/fbbc/app/turn-off-intermittent-fasting.webp";
import ScanBarCode from "../../../../../images/posters/fbbc/app/scan-bar-code.webp";
import ResettingProfile from "../../../../../images/posters/fbbc/app/resetting-profile.webp";
import CreateRecipe from "../../../../../images/posters/fbbc/app/create-recipe.webp";
import AdjustProtein from "../../../../../images/posters/fbbc/app/adjust-protein.webp";
import TurnOnMenstrualQuestion from "../../../../../images/posters/fbbc/app/turn-on-menstrual-question.webp";
import CopyingSavingMeals from "../../../../../images/posters/fbbc/app/copying-saving-meals.webp";
import EnterDailyWeight from "../../../../../images/posters/fbbc/app/enter-daily-weight.webp";
import UseIntermittentFasting from "../../../../../images/posters/fbbc/app/use-intermittent-fasting.webp";
import HighLowDays from "../../../../../images/posters/fbbc/app/high-low-days.webp";
import ChangeGoal from "../../../../../images/posters/fbbc/app/change-goal.webp";
import Favorites from "../../../../../images/posters/fbbc/app/favorites.webp";
import ChangeDiet from "../../../../../images/posters/fbbc/app/change-diet.webp";
import DailyMacroAdjustments from "../../../../../images/posters/fbbc/app/daily-macro-adjustments.webp";
import AddingCustomItem from "../../../../../images/posters/fbbc/app/adding-custom-item.webp";
import EditCheckinsPhotos from "../../../../../images/posters/fbbc/app/edit-checkins-photos.webp";
import ChangeCheckinDay from "../../../../../images/posters/fbbc/app/change-checkin-day.webp";
import CheckinComponents from "../../../../../images/posters/fbbc/app/checkin-components.webp";
import CarbFatAdjustment from "../../../../../images/posters/fbbc/app/carb-fat-adjustment.webp";
import CantHitProtein from "../../../../../images/posters/fbbc/app/cant-hit-protein.webp";
import BodyFat from "../../../../../images/posters/fbbc/app/body-fat.webp";
import Averages from "../../../../../images/posters/fbbc/app/averages.webp";
import AlcoholTracking from "../../../../../images/posters/fbbc/app/alcohol-tracking.webp";
import SearchingFood from "../../../../../images/posters/fbbc/app/searching-food.webp";
import ActivityLevel from "../../../../../images/posters/fbbc/app/activity-level.webp";
import FriendsPoster from "../../../../../images/posters/fbbc/app/friends.webp";
import MealPlanPoster from "../../../../../images/posters/fbbc/app/meal-plan.webp";
import PauseYourGoalPoster from "../../../../../images/posters/fbbc/app/pause-your-goal.webp";
import PracticeModePoster from "../../../../../images/posters/fbbc/app/practice-mode.webp";

const fbbcAppVideos = [
  {
    "title": "When to Adjust Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/When+to+Adjust+Goals.mp4",
    "thumbnail": WhenAdjustGoal,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "How Water Weight is Considered",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Water+Weight.mp4",
    "thumbnail": WaterWeight,
    "objectFit": "contain",
    "length": "1:00"
  },
  // {
  //   "title": "Vacation Mode",
  //   "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Vacation+Mode.mp4",
  //   "thumbnail": VacationMode,
  //   "objectFit": "contain",
  //   "length": "0:53"
  // },
  {
    "title": "How to Turn on Daily Weights",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Turn+on+Daily+Weights.mp4",
    "thumbnail": TurnOnDailyWeights,
    "objectFit": "contain",
    "length": "0:32"
  },
  {
    "title": "Turning Off Intermittent Fasting Timer",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Turn+Off+Fasting+Timer.mp4",
    "thumbnail": TurnOffFastingTimer,
    "objectFit": "contain",
    "length": "0:20"
  },
  {
    "title": "Scanning Bar Codes",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Scanner.mp4",
    "thumbnail": ScanBarCode,
    "objectFit": "contain",
    "length": "0:18"
  },
  {
    "title": "Resetting Your Profile",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Reset+Profile.mp4",
    "thumbnail": ResettingProfile,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "Creating a Recipe",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Recipes.mp4",
    "thumbnail": CreateRecipe,
    "objectFit": "contain",
    "length": "0:49"
  },
  {
    "title": "Adjusting Protein",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Protein+Adjustment.mp4",
    "thumbnail": AdjustProtein,
    "objectFit": "contain",
    "length": "0:24"
  },
  {
    "title": "Turning on the Menstrual Question for Check-ins",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Menstrual+Question.mp4",
    "thumbnail": TurnOnMenstrualQuestion,
    "objectFit": "contain",
    "length": "0:25"
  },
  {
    "title": "Copying and Saving Meals",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Meal+Controls.mp4",
    "thumbnail": CopyingSavingMeals,
    "objectFit": "contain",
    "length": "0:32"
  },
  {
    "title": "How to Enter Your Daily Weight",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Daily+weights.mp4",
    "thumbnail": EnterDailyWeight,
    "objectFit": "contain",
    "length": "0:24"
  },
  {
    "title": "How to Use the Intermittent Fasting Feature",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Intermittent+Fasting.mp4",
    "thumbnail": UseIntermittentFasting,
    "objectFit": "contain",
    "length": "0:49"
  },
  {
    "title": "High/Low Days",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/High+Low+Days.mp4",
    "thumbnail": HighLowDays,
    "objectFit": "contain",
    "length": "0:30"
  },
  {
    "title": "How to Change Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Goal+Changes.mp4",
    "thumbnail": ChangeGoal,
    "objectFit": "contain",
    "length": "0:45"
  },
  {
    "title": "Favorites",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Favorites.mp4",
    "thumbnail": Favorites,
    "objectFit": "contain",
    "length": "0:17"
  },
  {
    "title": "Changing Diet Restrictions",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Diet+Restrictions.mp4",
    "thumbnail": ChangeDiet,
    "objectFit": "contain",
    "length": "0:22"
  },
  {
    "title": "Daily Macro Adjustments",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Daily+Macro+Adjustments.mp4",
    "thumbnail": DailyMacroAdjustments,
    "objectFit": "contain",
    "length": "0:51"
  },
  {
    "title": "Adding an Item with Custom Macros",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Custom+Add.mp4",
    "thumbnail": AddingCustomItem,
    "objectFit": "contain",
    "length": "0:39"
  },
  {
    "title": "Editing Check-ins and Adding Photos or Measurements",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Editing+Check-Ins+and+Adding+Photos+or+Measurements.mp4",
    "thumbnail": EditCheckinsPhotos,
    "objectFit": "contain",
    "length": "1:14"
  },
  {
    "title": "How to Change Check in Day",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Change+Check-in+Day.mp4",
    "thumbnail": ChangeCheckinDay,
    "objectFit": "contain",
    "length": "0:15"
  },
  {
    "title": "Check In Components",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Check-In+Components.mp4",
    "thumbnail": CheckinComponents,
    "objectFit": "contain",
    "length": "0:55"
  },
  {
    "title": "Carb and Fat Adjustment",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Carb+and+Fat+Adjustment.mp4",
    "thumbnail": CarbFatAdjustment,
    "objectFit": "contain",
    "length": "0:29"
  },
  {
    "title": "What to Do When You Can't Hit Protein",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Can_t+Hit+Protein.mp4",
    "thumbnail": CantHitProtein,
    "objectFit": "contain",
    "length": "0:53"
  },
  {
    "title": "Body Fat",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Body+Fat.mp4",
    "thumbnail": BodyFat,
    "objectFit": "contain",
    "length": "0:55"
  },
  {
    "title": "Averages",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Averages.mp4",
    "thumbnail": Averages,
    "objectFit": "contain",
    "length": "0:24"
  },
  {
    "title": "Alcohol Tracking",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Alcohol+Tracking.mp4",
    "thumbnail": AlcoholTracking,
    "objectFit": "contain",
    "length": "0:26"
  },
  {
    "title": "Searching for a Food",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Searching+for+a+Food.mp4",
    "thumbnail": SearchingFood,
    "objectFit": "contain",
    "length": "0:41"
  },
  {
    "title": "Changing Activity Level",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Changing+Activity+Level.mp4",
    "thumbnail": ActivityLevel,
    "objectFit": "contain",
    "length": "0:31"
  },
  {
    "title": "Friends",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Friends.mp4",
    "thumbnail": FriendsPoster,
    "objectFit": "contain",
    "length": "9:41"
  },
  {
    "title": "Meal Plan",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Creating+a+Meal+Plan.mp4",
    "thumbnail": MealPlanPoster,
    "objectFit": "contain",
    "length": "5:18"
  },
  {
    "title": "Pause Your Goal",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Pause+your+Goal.mp4",
    "thumbnail": PauseYourGoalPoster,
    "objectFit": "contain",
    "length": "1:18"
  },
    {
    "title": "Practice Mode",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/tutorials/fbbc/app/Practice+Mode.mp4",
    "thumbnail": PracticeModePoster,
    "objectFit": "contain",
    "length": "1:25"
  }
]

export default fbbcAppVideos;
